import { render, staticRenderFns } from "./editDriverBankCard.vue?vue&type=template&id=4ecff197&scoped=true&"
import script from "./editDriverBankCard.vue?vue&type=script&lang=js&"
export * from "./editDriverBankCard.vue?vue&type=script&lang=js&"
import style0 from "./editDriverBankCard.vue?vue&type=style&index=0&id=4ecff197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecff197",
  null
  
)

export default component.exports